import Lottie from "react-lottie";
import { Button } from "@components";
import { routesFlat } from "@routes";
import * as lottie from "@assets/lottie";
import * as styles from "./styles";

const lineOptions = {
    ...lottie.defaultOptions,
    animationData: lottie.Line,
};

export default function Hero() {
    const btnProps = {
        to: routesFlat.products,
        primary: false,
        className: "w-[200px]",
    };
    return (
        <>
            <div className={styles.parentContainer}>
                {/* HALF CIRCLE */}
                <div className={styles.halfCircleWrapper}>
                    <div
                        className={styles.halfCircle}
                        style={{
                            top: "-107vh",
                            clipPath: "ellipse(200% 50% at 50% 100%)",
                        }}
                    ></div>
                </div>
                {/* SUB HEADER TEXT */}
                <div className={styles.textContainer}>
                    <div className={styles.textInnerWrapper}>
                        <div className={styles.headerText}>
                            SEE THE FOREST,{<br />}
                            AND THE TREES
                        </div>
                        <div className={styles.subHeaderText}>
                            A science nonprofit tracking every tree on Earth to
                            accelerate nature-based solutions
                        </div>
                        <Button {...btnProps}>See our data</Button>
                    </div>
                    <div className="mt-10 hidden lg:flex">
                        <Lottie options={lineOptions} height={380} width={50} />
                    </div>
                </div>
            </div>
        </>
    );
}
